export const LEGAL = {
  platformName: 'Le Petit Boulot',
  legalEntity: 'À COMPLÉTER — raison sociale de la société',
  legalForm: 'À COMPLÉTER — SAS / SASU / autre',
  registeredOffice: 'À COMPLÉTER — adresse du siège social',
  siren: 'À COMPLÉTER',
  vatNumber: 'À COMPLÉTER si applicable',
  publicationDirector: 'À COMPLÉTER',
  hostingProvider: 'Firebase Hosting / Google Cloud — préciser les coordonnées contractuelles',
  supportEmail: 'support@lepetitboulot.fr',
  privacyEmail: 'privacy@lepetitboulot.fr',
  consumerMediator: 'À COMPLÉTER — médiateur de la consommation référencé',
  consumerMediatorUrl: 'À COMPLÉTER',
};
